<div class="loans-detail-wrapper card" *ngIf="!fetchingData" (window:resize)="onResize()" [class.pastdetails]="viewType === 'Past'">
    <div class="go-back" (click)="showLoans()">
        <i class="left"></i> <span *ngIf="isMobile">GO BACK</span>
    </div>
    <div class="product-column">
        <div class="product-details">
            <div class="merchant-icon">
                <img
                    [src]="logoBaseUrl+'/logo-icons/'+(selectedLoan.MerchantName | lowercase)+'-logo-icon.png'"
                    [alt]="selectedLoan.MerchantName | lowercase"
                />
            </div>
            <div class="product-details-name">
                <div class="merchant-name" [textContent]="selectedLoan.MerchantName"></div>
            </div>
            <div class="loan-status-indicator">
                <div [class]="'emi-status ' + selectedLoan.Status" [textContent]="utilService.showStatus(selectedLoan)"></div>
                <div class="emi-due-date-indicator" *ngIf="!isMobile && (viewType === 'Active')">
                    <span class="red-color bold inactive-caption" *ngIf="(emiDateStatus.arrearTextBelowQuickPay.length>0) && (selectedLoan.Status !== 'Cancelled')"
                        [textContent]="emiDateStatus.arrearTextBelowQuickPay"></span>
                    <span class="black-color bold inactive-caption" *ngIf="(emiDateStatus.pendingTextBelowQuickPay.length>0) && (selectedLoan.Status !== 'Cancelled')"
                        [textContent]="emiDateStatus.pendingTextBelowQuickPay"></span>
                </div>
            </div>
        </div>
        <div class="loan-details loan-detail-section">
            <div class="loan-amount">
                <div class="title">
                    Loan amount
                </div>
                <div class="amount" [textContent]="(selectedLoan.LoanAmount | RupeeCurrencyPipe)"></div>
            </div>
            <div class="amount-pending-wrapper column-wrapper">
                <div class="title" [textContent]="(viewType === 'Active') ? 'Amount Pending' : 'Amount Paid'"></div>
                <div class="amount-pending" [textContent]="((viewType === 'Active') ? ((selectedLoan.TotalExpectedAmountAsOfToday) | number | RupeeCurrencyPipe) : (selectedLoan.LoanAmount | RupeeCurrencyPipe))"></div>
            </div>
            <div class="emi-tenure-section">
                <div class="title">
                    EMI tenure
                </div>
                <div class="emi-tenure" [textContent]="selectedLoan.NumbersOfMonth"></div>
            </div>
        </div>
    </div>
    <div class="payment-emi-section">
        <div class="row">
            <div class="payment-section col l11 m11 s11" *ngIf="(viewType === 'Active') && showLoanDetailComponents">
                    <div>LOAN PAYMENTS</div>
                    <div class="pay-emi-cta-body">
                        <div class="loan-repayment">
                            <table>
                                <tr>
                                    <td>PAY EMI</td>
                                    <td class="emi-amount" [textContent]="(showEMIAmount | RupeeCurrencyPipe)"></td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>Number of EMI's you want to Pay</div>
                                        <div class="month-of-emi">Month of EMI: <span
                                        [textContent]="getMonth(selectedLoan.NextDueDate)"></span></div>
                                    </td>
                                    <td class="amount-column">EMI: <span [textContent]="numberOfEmiDues"></span>
                                    </td>
                                </tr>
                                <tr class="loan-payment-emi-amount">
                                    <td>EMI Amount</td>
                                    <td [textContent]="nextDueAmount | RupeeCurrencyPipe" class="amount-column">
                                    </td>
                                </tr>
                                <tr>
                                    <td>Fee</td>
                                    <td [textContent]="selectedLoan.FeeAndPenaltyDue | RupeeCurrencyPipe" class="amount-column">
                                    </td>
                                </tr>
                                <tr>
                                    <td>Total Payable Amount</td>
                                    <td [textContent]="showEMIAmount | RupeeCurrencyPipe" class="total-amount amount-column"></td>
                                </tr>
                            </table>
                            <div class="pay-now-cta" *ngIf="((viewType === 'Active') && (selectedLoan.Status !== 'Approved'))">
                                <button
                                    class="pay-now-button btn btn-flat"
                                    [class.btn-wiggle]="!quickPayClicked"
                                    id="_quickPay"
                                    angulartics2On="click"
                                    angularticsEvent="quick-pay"
                                    angularticsCategory="quick-pay"
                                    (click)="triggerSMSLink()"
                                >
                                    PAY NOW
                                </button>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
        <div class="hr-line  col l11 m12 s12" *ngIf="showLoanDetailComponents && isMobile"></div>
        <div class="more-toggle" (click)="showLoanComponents()" *ngIf="isMobile && (viewType === 'Active')" [class.expanded]="showLoanDetailComponents">
            <span [textContent]="showLoanDetailComponents ? 'LESS' : 'MORE'" ></span><i [class]="showLoanDetailComponents ? 'up' : 'down'"></i>
        </div>
        <div class="row">
            <div class="schedule-section col l11 m12 s12" *ngIf="selectedLoan.Status !== 'Cancelled'">
                        <div class="header">
                            All EMI's
                        </div>
                        <table class="striped" *ngIf="selectedLoan.Status !== 'Cancelled'">
                            <tr class="schedule-headers">
                                <th>Due Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                            <tr *ngFor="let emi of schedulerRepayments; let i = index" [class.hide]="(schedulerRepayments && (schedulerRepayments.length > 6) && (i > 5) && !toggleScheduleTable)">
                                <td class="schedule-col date" [textContent]="emi.DueDate | date"></td>
                                <td class="schedule-col amount" [textContent]="(emi.State == 'Paid' ? (emi.TotalPaid | number) : ((emi.PrincipalDue + emi.InterestDue) | number)) | RupeeCurrencyPipe"></td>
                                <td class="schedule-col state" [class.emi-upcoming]="emi.State == 'Upcoming'"
                                [class.emi-late]="emi.State == 'Late'" [class.emi-Paid]="emi.State == 'Paid'"
                                [class.emi-pending]="emi.State == 'To Be paid'" [textContent]="emi.State"></td>
                            </tr>
                        </table>
                        <div *ngIf="((schedulerRepayments) && (schedulerRepayments.length > 6))" class="view-more-section">
                            <a class="toggleButton" (click)="showHideToggle()" [textContent]="(toggleScheduleTable) ? 'VIEW LESS' : 'VIEW MORE'"></a>
                        </div>
            </div>
        </div>
    </div>
</div>

<div class="loader-text" *ngIf="fetchingData">Fetching loan details......</div>